__turbopack_context__.v({
  "blogContent": "blog-module__O4kYha__blogContent",
  "toc": "blog-module__O4kYha__toc",
});
